module.exports = __webpack_public_path__ + "img/p4.71716d31.jpg";